const AUTH = 'user/';
const LOG_IN = 'login';
const CHANGE_PASSWORD = 'change';
const LOGOUT = 'logout';
const MANUFACTURER = 'manufacturer';
const AREAS = 'area';
const COUNTRY = 'country';
const SERVICE = 'service';
const SPAREPARTS = 'spare-part';
const MODEL = 'model';
const MODEL_YEAR = 'year';
const RAGIONS = 'region';
const CUSTOMERS = 'customer';
const OPERATION = 'operation';
const BAN = 'ban';
const Coupon = 'coupon';
const SLOT = 'slot';
const ORDER = 'order';
const RECALCULATE="recalculate"
const OREDR_HISTORY='user-orders'
const COMPLAINT ='complaint'
const RESPOND="respond"
const REVIEW="review"
const CATALOGUE = "catalogue"
const PRODUCTS = "product"
const CAREER = "career"
const APPLICATION = 'application'
const SLIDERS = 'sliders'
const SOCIAL = "social"
const CONTACT_US = "contact_us"

export abstract class EndPoints {
  public static LOG_IN_ENDPOINT = LOG_IN;
  public static CHANGE_PASSWORD_ENDPOINT = AUTH + CHANGE_PASSWORD;
  public static LOGOUT_ENDPOINT = LOGOUT;
  public static BAN_ENDPOINT = AUTH + BAN;
  public static MANUFACTURER_ENDPOINT = MANUFACTURER;
  public static RAGIONS_ENDPOINT = RAGIONS;
  public static MODEL_ENDPOINT = MODEL;
  public static MODEL_YEAR_ENDPOINT = MODEL_YEAR;
  public static CUSTOMERS_ENDPOINT = CUSTOMERS;
  public static AREAS_ENDPOINT = AREAS;
  public static COUNTRY_ENDPOINT = COUNTRY;
  public static SERVICE_ENDPOINT = SERVICE;
  public static OPERATION_ENDPOINT = OPERATION;
  public static COUPON_ENDPOINT = Coupon;
  public static SPAREPARTS_ENDPOINT = SPAREPARTS;
  public static SLOT_ENDPOINT = SLOT;
  public static ORDER_ENDPOINT = ORDER;
  public static RECALCULATE_ENDPOINT = `${ORDER}/${RECALCULATE}`;
  public static OREDR_HISTORY_ENDPOINT = `${ORDER}/${OREDR_HISTORY}`;
  public static COMPLAINT_ENDPOINT = COMPLAINT;
  public static RESPOND_ENDPOINT = RESPOND;
  public static REVIEW_ENDPOINT = REVIEW;
  public static CATALOGUE_ENDPOINT = CATALOGUE;
  public static PRODUCT_ENDPOINT = PRODUCTS;
  public static CAREER_ENDPOINT = CAREER;
  public static APPLICATION_ENDPOINT = APPLICATION;
  public static SLIDERS_ENDPOINT = SLIDERS;
  public static SOCIAL_ENDPOINT = SOCIAL;
  public static CONTACT_US_ENDPOINT = CONTACT_US;
}
